(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'colorControl',
            [
                'CHROME',
                ColorControlFactory
            ]
        );

    // Factory Method
    function ColorControlFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.PROJECT.CONTROL.COLOR + CHROME.POSTFIX
        };

    }
})();



